import { Box, Group, Image, List, SimpleGrid, Stack } from "@mantine/core";
import { useTranslation } from "react-i18next";

import {
  Card,
  Contact,
  Footer,
  Gallery,
  HeroBackground,
  Section,
  SectionText,
  SectionTitle,
} from "components";
import {
  CHECK_FILLED_ICON,
  NUMBER_OF_PARTNERS,
  NUMBER_OF_SERVICES,
  TOWN_IMG,
} from "constants/app";
import classes from "./index.module.css";

const licenceImages = [
  { src: "/assets/licence1.png" },
  { src: "/assets/licence2.png" },
  { src: "/assets/licence3.png" },
  { src: "/assets/licence4.png" },
  { src: "/assets/licence5.png" },
];

const AboutUsPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <HeroBackground image={TOWN_IMG}>
        <Section hero={true}>
          <Stack maw={780}>
            <Group>
              <Image h="auto" w="auto" src={CHECK_FILLED_ICON} />
              <SectionText text={t("about_us.hero.preheading")}></SectionText>
            </Group>
            <SectionTitle title={t("about_us.hero.title")} />
            <SectionText text={t("about_us.hero.descriptions.0")} />
            <SectionText text={t("about_us.hero.descriptions.1")} />
          </Stack>
        </Section>
      </HeroBackground>
      <Section>
        <SectionTitle variant="dark" title={t("about_us.additional.title")} />
        <SectionText
          variant="light"
          text={t("about_us.additional.description")}
        />
        <SectionText
          variant="light"
          text={t("about_us.additional.services.title")}
        />
        <List>
          {Array(NUMBER_OF_SERVICES)
            .fill(null)
            .map((_, index) => (
              <List.Item key={index}>
                <SectionText
                  variant="dark"
                  bold={true}
                  inline={true}
                  withoutMargin={true}
                  text={t(`about_us.additional.services.items.${index}.name`)}
                />
                <SectionText
                  variant="light"
                  inline={true}
                  withoutMargin={true}
                  text={t(`about_us.additional.services.items.${index}.value`)}
                />
              </List.Item>
            ))}
        </List>
        <SectionText
          variant="light"
          text={t("about_us.additional.services.trust")}
        />
      </Section>
      <Section>
        <SectionTitle variant="dark" title={t("about_us.licence.title")} />
        <SectionText variant="light" text={t("about_us.licence.description")} />
        <Gallery images={licenceImages} />
      </Section>
      <Section title={t("about_us.partners.title")} titleVariant="dark">
        <SimpleGrid
          cols={{ base: 1, xs: 2, md: 3 }}
          spacing={{ base: 12, md: 32, lg: 50 }}
          className={classes.cards}
        >
          {Array(NUMBER_OF_PARTNERS)
            .fill(null)
            .map((_, index) => (
              <Card key={index}>
                <SectionTitle
                  title={t(`about_us.partners.list.${index}`)}
                  variant="accent"
                  center={true}
                />
              </Card>
            ))}
        </SimpleGrid>
      </Section>
      <Section title={t("about_us.route.title")} titleVariant="accent">
        <Box className={classes.videoWrapper} ta="center">
          <iframe
            src="https://www.youtube.com/embed/0oZIiP7Ips0?si=wq0HWEwWxvJrmegZ"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </Box>
      </Section>
      <Contact />
      <Footer />
    </>
  );
};

export default AboutUsPage;
